<div [appTooltip]="getTransactionStatusTranslation(status)">
  <ng-container [ngSwitch]="status">
    <svg-icon *ngSwitchCase="TransactionStatus.COMPLETED" src="/assets/icons/24/check.svg" svgClass="icon-check">
    </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.USED" src="/assets/icons/24/check.svg" svgClass="icon-check"> </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.CREATED" src="/assets/icons/24/check.svg" svgClass="icon-check">
    </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.VERIFIED" src="/assets/icons/24/check.svg" svgClass="icon-check">
    </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.OK" src="/assets/icons/24/check.svg" svgClass="icon-check"> </svg-icon>

    <svg-icon *ngSwitchCase="TransactionStatus.NEW" src="/assets/icons/24/time.svg" svgClass="icon-time"> </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.SENT" src="/assets/icons/24/time.svg" svgClass="icon-time"> </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.PENDING" src="/assets/icons/24/time.svg" svgClass="icon-time">
    </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.NOTIFIED" src="/assets/icons/24/time.svg" svgClass="icon-time">
    </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.WAITING" src="/assets/icons/24/time.svg" svgClass="icon-time">
    </svg-icon>
    <svg-icon *ngSwitchCase="TransactionStatus.BEFORE_SEND" src="/assets/icons/24/time.svg" svgClass="icon-time">
    </svg-icon>

    <svg-icon *ngSwitchCase="TransactionStatus.ERROR" src="/assets/icons/24/warning.svg" svgClass="icon-warning">
    </svg-icon>

    <svg-icon *ngSwitchCase="TransactionStatus.CANCELLED" src="/assets/icons/24/error.svg" svgClass="icon-error">
    </svg-icon>
  </ng-container>
</div>
